import store, { resetStores } from 'src/store'
import {
  markClientLogoutInProgress,
  notifyLocalAuthStateChanged,
} from 'src/shared/auth/logoutSignals'

export const logoutHandlerSupport = () => {
  markClientLogoutInProgress()
  let lanCode = sessionStorage.getItem('languageCode')
  sessionStorage.clear()
  localStorage.removeItem('token')
  localStorage.removeItem('authorities')
  localStorage.removeItem('FCMToken')
  localStorage.removeItem('submittedFCMTokenForThisUser')
  localStorage.removeItem('lastChosenFlow')
  sessionStorage.setItem(
    'languageCode',
    lanCode ? lanCode : navigator?.language || navigator?.userLanguage.split('-')[0],
  )
  markClientLogoutInProgress()
  store.dispatch(resetStores())
  notifyLocalAuthStateChanged()
}
